// import React, { useEffect, useState } from 'react';  
// import { useParams, Link } from 'react-router-dom';  
// import styled, { keyframes } from 'styled-components';  
// import { fetchNewtelemetry } from './api'; // ここで関数をインポートします。  
// import Header from '../components/Header';  
  
// const Container = styled.div`  
//   display: flex;  
//   flex-direction: column;  
//   align-items: center; /* 横の中央に配置 */  
//   padding: 20px;  
//   background: linear-gradient(to right, #006331, #B2D7C5);  
//   min-height: 100vh;  
//   font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;  
//   color: #ffffff;  
//   text-align: center;  
// `;  
  
// const BoldLink = styled(Link)`  
//   color: #FFFFFF;  
//   text-decoration: none;  
//   font-weight: bold;  
//   display: inline-block;  
//   margin-top: 16px;  
// `;  
  
// const Table = styled.table`  
//   width: 100%;  
//   max-width: 800px;  
//   border-collapse: collapse;  
//   margin-top: 20px;  
//   background-color: rgba(255, 255, 255, 0.1);  
//   border-radius: 8px;  
//   overflow: hidden;  
// `;  
  
// const TableHead = styled.thead`  
//   background-color: rgba(0, 0, 0, 0.2);  
// `;  
  
// const TableRow = styled.tr`  
//   &:nth-child(even) {  
//     background-color: rgba(255, 255, 255, 0.1);  
//   }  
  
//   @media (max-width: 768px) {  
//     display: block;  
//     margin-bottom: 10px;  
//   }  
// `;  
  
// const TableHeader = styled.th`  
//   padding: 10px;  
//   border: 1px solid rgba(255, 255, 255, 0.2);  
  
//   @media (max-width: 768px) {  
//     // display: inline-block;  
//     width: auto;  
//     padding: 5px;  
//   }  
// `;  
  
// const TableCell = styled.td`  
//   padding: 10px;  
//   border: 1px solid rgba(255, 255, 255, 0.2);  
//   white-space: nowrap; /* これを追加 */  
//   @media (max-width: 768px) {  
//     display: inline-block;  
//     width: auto;  
//     padding: 5px;  
//   }  
// `;  
  
// const zoomInOut = keyframes`  
//   0% {  
//     transform: scale(1);  
//   }  
//   50% {  
//     transform: scale(1.2);  
//   }  
//   100% {  
//     transform: scale(1);  
//   }  
// `;  
  
// const LoadingContainer = styled.div`  
//   display: flex;  
//   flex-direction: column;  
//   justify-content: center;  
//   align-items: center;  
//   height: 100vh;  
//   background: linear-gradient(to right, #006331, #B2D7C5);  
// `;  
  
// const LoadingText = styled.div`  
//   font-size: 2rem;  
//   color: #FFFFFF;  
//   font-weight: bold;  
//   margin-bottom: 20px;  
// `;  
  
// const LoadingImage = styled.img`  
//   width: 100px;  
//   height: 100px;  
//   animation: ${zoomInOut} 2s infinite;  
//   border-radius: 10px;  /* ここを追加 */  
// `;  
  
// function NewDataPage() {  
//   const { id } = useParams();  
//   const [newData, setNewData] = useState([]);  
//   const [loading, setLoading] = useState(true);  
//   const [error, setError] = useState(null);  
  
//   useEffect(() => {  
//     let isMounted = true; // コンポーネントがマウントされているかどうかを追跡するフラグ  
  
//     fetchNewtelemetry(id, 10)  
//       .then(data => {  
//         if (isMounted) {  
//           setNewData(data);  
//         }  
//       })  
//       .catch(e => {  
//         if (isMounted) {  
//           setError(e.message);  
//         }  
//       })  
//       .finally(() => {  
//         if (isMounted) {  
//           setLoading(false);  
//         }  
//       });  
  
//     return () => {  
//       isMounted = false; // クリーンアップ時にフラグをfalseに設定  
//     };  
//   }, [id]);  
  
//   if (loading) {  
//     return (  
//       <LoadingContainer>  
//         <LoadingText>Loading...</LoadingText>  
//         <LoadingImage src="/robo_on.jpg" alt="Loading" />  
//       </LoadingContainer>  
//     );  
//   }  
  
//   if (error) {  
//     return <Container>Error: {error}</Container>;  
//   }  
  
//   return (  
//     <Container>  
//       <Header />  
//       <h1>収穫状況履歴</h1>  
//       <p>{id}</p>  
//       <Table>  
//         <TableHead>  
//           <TableRow>  
//             {/* <TableHeader>Type</TableHeader> */}  
//             {/* <TableHeader>DeviceID</TableHeader> */}  
//             <TableHeader>Date</TableHeader>  
//             <TableHeader>Battery</TableHeader>  
//             <TableHeader>Robot Mode</TableHeader>  
//             <TableHeader>Round Trip Count</TableHeader>  
//             <TableHeader>Event</TableHeader>  
//             <TableHeader>Size</TableHeader>  
//             <TableHeader>Result</TableHeader>  
//           </TableRow>  
//         </TableHead>  
//         <tbody>  
//           {newData.map((item, index) => (  
//             <TableRow key={index}>  
//               {/* <TableCell>{item.Type}</TableCell> */}  
//               {/* <TableCell>{item.deviceId}</TableCell> */}  
//               <TableCell>{item.date}</TableCell>  
//               <TableCell>{item.battery}</TableCell>  
//               <TableCell>{item.robot_mode}</TableCell>  
//               <TableCell>{item.round_trip_count_current}</TableCell>  
//               <TableCell>{item.event}</TableCell>  
//               <TableCell>{item.size}</TableCell>  
//               <TableCell>{item.result}</TableCell>  
//             </TableRow>  
//           ))}  
//         </tbody>  
//       </Table>  
//       <BoldLink to={`/${id}`}>Back</BoldLink>  
//     </Container>  
//   );  
// }  
  
// export default NewDataPage;  


import React, { useEffect, useState } from 'react';  
import { useParams, Link } from 'react-router-dom';  
import styled, { keyframes } from 'styled-components';  
import { fetchNewtelemetry } from './api'; // ここで関数をインポートします。  
import Header from '../components/Header';  
  
const Container = styled.div`  
  display: flex;  
  flex-direction: column;  
  align-items: center; /* 横の中央に配置 */  
  padding: 20px;  
  background: linear-gradient(to right, #006331, #B2D7C5);  
  min-height: 100vh;  
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;  
  color: #ffffff;  
  text-align: center;  
`;  
  
const BoldLink = styled(Link)`  
  color: #FFFFFF;  
  text-decoration: none;  
  font-weight: bold;  
  display: inline-block;  
  margin-top: 16px;  
`;  
  
const zoomInOut = keyframes`  
  0% {  
    transform: scale(1);  
  }  
  50% {  
    transform: scale(1.2);  
  }  
  100% {  
    transform: scale(1);  
  }  
`;  
  
const LoadingContainer = styled.div`  
  display: flex;  
  flex-direction: column;  
  justify-content: center;  
  align-items: center;  
  height: 100vh;  
  background: linear-gradient(to right, #006331, #B2D7C5);  
`;  
  
const LoadingText = styled.div`  
  font-size: 2rem;  
  color: #FFFFFF;  
  font-weight: bold;  
  margin-bottom: 20px;  
`;  
  
const LoadingImage = styled.img`  
  width: 100px;  
  height: 100px;  
  animation: ${zoomInOut} 2s infinite;  
  border-radius: 10px;  /* ここを追加 */  
`;  
  
const ItemContainer = styled.div`  
  background-color: rgba(255, 255, 255, 0.1);  
  border-radius: 8px;  
  padding: 20px;  
  margin: 10px 0;  
  width: 100%;  
  max-width: 800px;  
  text-align: left;  
`;  
  
function NewDataPage() {  
  const { id } = useParams();  
  const [newData, setNewData] = useState([]);  
  const [loading, setLoading] = useState(true);  
  const [error, setError] = useState(null);  
  
  useEffect(() => {  
    let isMounted = true; // コンポーネントがマウントされているかどうかを追跡するフラグ  
  
    fetchNewtelemetry(id, 30)  
      .then(data => {  
        if (isMounted) {  
          setNewData(data);  
        }  
      })  
      .catch(e => {  
        if (isMounted) {  
          setError(e.message);  
        }  
      })  
      .finally(() => {  
        if (isMounted) {  
          setLoading(false);  
        }  
      });  
  
    return () => {  
      isMounted = false; // クリーンアップ時にフラグをfalseに設定  
    };  
  }, [id]);  
  
  if (loading) {  
    return (  
      <LoadingContainer>  
        <LoadingText>Loading...</LoadingText>  
        <LoadingImage src="/robo_on.jpg" alt="Loading" />  
      </LoadingContainer>  
    );  
  }  
  
  if (error) {  
    return <Container>Error: {error}</Container>;  
  }  
  
  return (  
    <Container>  
      <Header />  
      <h1>収穫状況履歴</h1>  
      <p>{id}</p>  
      {newData.map((item, index) => (  
        <ItemContainer key={index}>  
          <pre>{JSON.stringify(item, null, 2)}</pre>  
        </ItemContainer>  
      ))}  
      <BoldLink to={`/${id}`}>Back</BoldLink>  
    </Container>  
  );  
}  
  
export default NewDataPage;  